import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Month, monthYear} from '@planning/model/enum';
import {MatButtonToggleChange} from '@angular/material/button-toggle';
import {MonthHelper} from '@shared/helper';

@Component({
  selector: 'app-dialog-calendar',
  templateUrl: './dialog-calendar.component.html',
  styleUrls: ['./dialog-calendar.component.scss']
})
export class DialogCalendarComponent implements OnInit {
  @Input() currentMonth!: Month[];
  @Output() onValidate: EventEmitter<Month[]> = new EventEmitter();

  months: Month[] = monthYear;

  constructor() {
  }

  ngOnInit(): void {
  }

  setMonthSelected(button: MatButtonToggleChange) {
    if (button.source.checked) {
      this.currentMonth.push(button.value);
    } else {
      this.currentMonth = this.currentMonth.filter(m => m != button.value);
    }
  }

  validate() {
    this.onValidate.emit(MonthHelper.sortMonths(this.currentMonth));
  }
}
